import { createContext } from 'react';

import { SelectedGroupContextProps } from './SelectedGroupContext.types';

export const SelectedGroupContext = createContext<SelectedGroupContextProps | undefined>(undefined);
